import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LanguageService } from 'src/app/modules/shared/services/language.service';

@Component({
  standalone: false,
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.css']
})

export class ConfirmDialogComponent implements OnInit {

  variables: any;
  local_data: any;
  input: boolean = false;
  message: string = '';
  isCompleteOrIncomplete: boolean = false;
  justification: string = '';
  showJustificationInput: boolean = false;
  hasTasks = false;
  hasAiItems = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    private languageService: LanguageService
  ) {
    this.local_data = { ...data };
    this.isCompleteOrIncomplete = this.local_data.isCompleteOrIncomplete;
  }

  ngOnInit(): void {
    this.languageService.translations$.subscribe((vars: any) => {
      this.variables = vars;
    });

    this.hasTasks = this.local_data.hasTasks
    this.hasAiItems = this.local_data.hasAiItems || false;
  }

  doActionIsComplete(value: boolean) {
    if (!this.showJustificationInput || this.justification) {
      this.dialogRef.close({
        data: this.input,
        isComplete: value,
        isIncomplete: !value,
        justification: this.justification
      });
    }
  }

  toggleJustificationInput() {
    if (this.local_data.needJustification) {
      this.showJustificationInput = !this.showJustificationInput;
    } else {
      this.doActionIsComplete(true);
    }
  }
}
